'use strict';

import * as Props from '../Props';

const angular = require('angular');

const InlineAssocFiles = {
    Basic: {
        'ControlType': 'InlineAssocFiles',
        'Label': {
            name: 'label',
            selectedValue: 'Associate Files',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
        },
        'Text': {
            name: 'text',
            selectedValue: 'Associate Files',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('InlineAssocFiles'),
        'Data Field Name': Props.getDataFieldName('InlineAssocFiles'),
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },       
    },
    Association: {
        'AddSetup': {
            type: "button",
            title: "Add Setup",
            selectedValue: "1",
            icon: "fa fa-plus",
            onClickFunction: "addcolumnName",
            clicked: false
        },
        'selectedColumn': {
            'Parameters': {
                type: "table",
                list: [
                    {
                        value: {
                            selectedValue: "",
                            type: "dropdown",
                            inputWidth: "width:100px;"
                        },
                        sorting: {
                            selectedValue: "",
                            type: "radio",
                        }
                    }
                ],
                hidden: true
            },
            'table': {
                type: "table",
                default: "datasource",
                list: [
                    {
                        id: 1,
                        Value: {
                            name: {
                                "id": "2",
                                "fieldName": "document_ref",
                                "colDisplayName": "Doc Ref",
                                "dataType": "text",
                                "function": "openDocument",
                                "widthOfColumn": 125,
                                "isSortSupported": true,
                                "isCustomAttributeColumn": false,
                            },
                            type: "dropdown",
                            inputWidth: "width:100px;",
                            disable: false,
                        },
                        Sorting: {
                            name: 'sorting',
                            type: 'radio',
                            selectedValue: '',
                            disable: false,
                            list: [
                                {
                                    name: 'Descending',
                                    value: '1'
                                },
                                {
                                    name: 'Ascending',
                                    value: '0'
                                },
                            ]
                        },
                        showUpdateOptions: true
                    }
                ],
                hidden: true
            },
            hidden: true
        },
        'Name': {
            selectedValue: 'File Attributes Setup',
            hidden: true
        },
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Borders: {
        'border-style-group': {
            type: 'style-group',
            members: {
                'border-width': {
                    type: 'number',
                    title: 'border.width',
                    selectedValue: 1,
                    min: '1',
                    max: '99',
                    default: 1,
                    onChangeFunction: 'updateStyle'
                },
                'border-color': {
                    type: 'color-picker',
                    title: 'border.color',
                    selectedValue: '#cccccc',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle'
                }
            }
        },
        'Name': {
            selectedValue: 'Borders',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: {
        'font-style-group': {
            type: 'style-group',
            members: {
                'font-family': {
                    type: 'dd',
                    title: 'font.family',
                    selectedValue: 'Helvetica',
                    options: ['Arial', 'Arial Black', 'Bookman Old Style', 'Calibri', 'Century Gothic', 'Comic Sans MS', 'Courier', 'Courier New', 'Garamond', 'Georgia', 'Helvetica', 'Impact', 'Palatino Linotype', 'Sans Serif', 'Sofia Pro Regular', 'Sofia Pro Semi Bold', 'Times', 'Times New Roman', 'Trebuchet MS', 'Verdana']
                },
                'font-size': {
                    type: 'number',
                    title: 'font.size',
                    selectedValue: 14,
                    min: '1',
                    max: '20',
                    default: 16
                },
            }
        },
        'Name': {
            selectedValue: 'control.style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Advanced: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Reportable': angular.copy(Props.Reportable),
        Name: {
            selectedValue: 'Advanced',
            hideSection: false,
            hidden: true
        },
    },
    Events: {
        Name: {
            selectedValue: 'Events',
            hideSection: false,
            hidden: true
        },
        load: angular.copy(Props.elementEventsObject).load,
        click: {
            name: 'onClick',
            type: 'event',
            selectedValue: '',
            xmlValue: '',
            onClickFunction: 'openCodeEditorDialog'
        },
    },
    
};
 
   

export default InlineAssocFiles;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Inlineassociation.ts